'use strict';

angular.module('webmailWrapper')

.config(
    function(wizardProvider) {
        var getDomainName = [
            'userContext',
            function(userContext) {
                return userContext.getMailbox().domainNameUnicode;
            }
        ];

        wizardProvider.wizard(
            'newMailbox',
            {
                data: function () {
                    return {
                        mailbox: {
                            emailAddress: '',
                            forwarderTargets: [],
                            isAdmin: false,
                            spamFilter: {
                                bannedFilesChecks: false,
                                headerChecks: false,
                                malwareChecks: false,
                                spamChecks: false,
                                deleteSpam: false,
                                modifySubjectOnSpam: false,
                                spamLevel: 'low',
                                useGreylisting: false
                            },
                            storageQuota: 1024,
                            type: 'ImapMailbox'
                        },
                        password: '',
                        password2: '',
                        spamProfile: null,
                        verification: {
                            status: null
                        }
                    };
                },
                submit: [
                    'wizardData', 'mailboxModel', 'alertManager', '$q', 'translationProvider',
                    function (wizardData, mailboxModel, alertManager, $q, translationProvider) {
                        var newMailbox = JSON.parse(JSON.stringify(wizardData.mailbox));
                        var mailDomain = wizardData.mailbox.emailAddress.split('@')[1];

                        var forwarderTargetsIncludeExternal = wizardData.mailbox.forwarderTargets
                        .some(
                            function(target) {
                                return target.split('@')[1] !== mailDomain;
                            }
                        );

                        newMailbox.productCode
                        = {
                            ExchangeMailbox: 'email-msexchange-mailbox-1m',
                            Forwarder: forwarderTargetsIncludeExternal ? 'email-forwarder-external-12m' : 'email-forwarder-internal',
                            ImapMailbox: 'email-imap-mailbox-12m'
                        }
                        [wizardData.mailbox.type];

                        return mailboxModel.createMailbox(newMailbox, wizardData.password)
                        .then(
                            function () {
                                alertManager.success(translationProvider.instant('TR_050719-43d4e7_TR'));
                            },
                            function (reason) {
                                alertManager.error(translationProvider.instant('TR_070525-f3c725_TR'));
                                return $q.reject(reason);
                            }
                        );
                    }
                ],
                steps: [
                    {
                        name: 'basicData',
                        controller: 'EmailNewBasicDataCtrl',
                        templateUrl: require('@/views/email/new/basicData.html'),
                        resolve: {
                            domainName: getDomainName,
                        }
                    },
                    {
                        name: 'mailboxImap',
                        controller: 'EmailNewMailboxCtrl',
                        templateUrl: require('@/views/email/new/mailbox.html'),
                        resolve: {
                            domainName: getDomainName,
                            storageQuotaOptions: [
                                'emailDomainSettingsManager', 'emailStorageHelper',
                                function(emailDomainSettingsManager, emailStorageHelper) {
                                    return emailDomainSettingsManager.getMailboxFreeStorageQuota()
                                    .then(emailStorageHelper.generateStorageQuotaOptions);
                                }
                            ]
                        },
                        show: [
                            'wizardData',
                            function (wizardData) {
                                return wizardData.mailbox.type === 'ImapMailbox';
                            }
                        ]
                    },
                    {
                        name: 'forwarderTargets',
                        controller: 'EmailNewForwarderTargetsCtrl',
                        templateUrl: require('@/views/email/new/forwarderTargets.html'),
                        resolve: {
                            domainName: getDomainName
                        },
                        show: [
                            'wizardData',
                            function (wizardData) {
                                return wizardData.mailbox.type === 'Forwarder';
                            }
                        ]
                    },
                    {
                        name: 'spamFilter',
                        controller: 'EmailNewSpamFilterCtrl',
                        templateUrl: require('@/views/email/new/spamFilter.html'),
                        resolve: {
                            spamProfiles: [
                                'spamProfiles',
                                function(spamProfiles) {
                                    return spamProfiles.getProfiles();
                                }
                            ]
                        }
                    },
                    {
                        name: 'confirmation',
                        controller: 'EmailNewConfirmationCtrl',
                        templateUrl: require('@/views/email/new/confirmation.html')
                    }
                ]
            }
        );
    }
);
